export default __webpack_public_path__ + "static/media/run-buddy.0e489a76.gif";